import { useForm } from 'react-hook-form';
import API from '../../../Utils/api';

import styles from './AthleteSearchPage.module.css';
import { toast } from 'react-toastify';
import { getCreateAthleteFeedback } from './createAthleteFeedback';

export default function CreateAthleteModal({ onClose, coachId }) {
    const { register, handleSubmit } = useForm();

    const createAthlete = async ({ email, firstName, lastName, birthYear }) => {
        const trimmedEmail = (email || '').trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // Email is optional; only a supplied address must be well-formed
        if (trimmedEmail && !emailRegex.test(trimmedEmail)) {
            toast.error('Please enter a valid email address, or leave it blank', {
                position: 'bottom-center'
            });
            return;
        }

        try {
            const { data } = await API.createNewAthleteThroughRelationship(
                {
                    email: trimmedEmail,
                    firstName,
                    lastName,
                    birthYear
                },
                coachId
            );
            onClose?.();
            const { type, message } = getCreateAthleteFeedback(data);
            toast[type](message, {
                position: 'bottom-center',
                ...(type === 'warning' && { autoClose: false })
            });
        } catch (error) {
            toast.error(error?.response?.data?.error || 'Could not create the athlete', {
                position: 'bottom-center'
            });
        }
    };

    return (
        <div className={styles.athleteModalWrap}>
            <form className={styles.form}>
                <h4>Athlete's Information</h4>
                <div className='form-group'>
                    <label htmlFor='email'>Email</label>
                    <input
                        id='email'
                        {...register('email')}
                        type='email'
                        className='form-control'
                    />
                </div>
                <div className='form-row'>
                    <div className='form-group'>
                        <label htmlFor='firstName'>First Name *</label>
                        <input
                            id='firstName'
                            {...register('firstName', { required: true })}
                            className='form-control'
                        />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='lastName'>Last Name *</label>
                        <input
                            id='lastName'
                            {...register('lastName', { required: true })}
                            className='form-control'
                        />
                    </div>
                </div>
                <div className='form-group'>
                    <label htmlFor='birthYear'>Birth Year *</label>
                    <input
                        id='birthYear'
                        {...register('birthYear', { required: true })}
                        className='form-control'
                    />
                </div>
            </form>
            <button className='btn btn-primary' onClick={handleSubmit(createAthlete)}>
                Create Athlete
            </button>
        </div>
    );
}
